<!--完成收款弹窗形式 销售 收款 -->
<template>
  <div>
    <el-form
      :rules="rules"
      :model="submitData"
      label-width="120px"
      ref="submitData"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="单据总金额">
              <el-input v-model="finishData.allMoney" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="type == 0 ? '收款金额' : '付款金额'">
              <el-input v-model="finishData.allMoney" disabled></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item
              :label="type == 0 ? '实收金额' : '实付金额'"
              prop="NowPay"
            >
              <el-input
                type="number"
                step="1"
                v-model="submitData.NowPay"
                :min="0"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="结算方式" prop="PayType">
              <el-select
                v-model="submitData.PayType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in payWayList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="备注">
              <el-input v-model="submitData.Remark"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-ctn">
      <el-button size="small" class="search-btn" @click="cancel()"
        >取消</el-button
      >
      <el-button
        size="small"
        class="search-btn btn-primary"
        @click="submitForm()"
        :disabled="!canSubmit"
        >提交确认</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["finishData", "type"],
  components: {},
  data() {
    return {
      payDataCount: 0,
      waitPay: 0,
      payWayList: [],
      submitData: {
        OrderId: "",
        NowPay: "",
        PayType: "",
        Remark: "",
        Type: 0,
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "blur" }],
        NowPay: [{ required: true, message: "该项必填", trigger: "blur" }],
      },
      canSubmit: true, // 是否可以提交
    };
  },
  mounted() {
    if (this.finishData.payType) {
      this.submitData.PayType = this.finishData.payType;
    }
    this.submitData.OrderId = this.finishData.orderId;
    if (this.finishData.shareCost)
      this.submitData.NowPay =
        (Number(this.finishData.allMoney) + Number(this.finishData.shareCost)).toFixed(2);
    else this.submitData.NowPay = this.finishData.allMoney;
    this.submitData.Type = this.type;
    this.getPay();
  },
  methods: {
    cancel() {
      this.$emit("closeFinish");
    },
    submitForm() {
      if (this.submitData.NowPay < 0) {
        if (this.type == 0) this.$util.warningMsg("实收金额不能小于0");
        else this.$util.warningMsg("实付金额不能小于0");
        return;
      }
      if (this.submitData.NowPay == 0) {
        let title = "";
        if (this.type == 0) title = "实收金额当前等于0，仍确定要提交吗？";
        else title = "实付金额当前等于0，仍确定要提交吗？";

        this.$confirm(title, "提示", {
          confirmButtonText: "确定继续提交",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs["submitData"].validate((valid) => {
              if (valid) {
                this.canSubmit = false;
                this.$util
                  .axiosPost({
                    url: "/api/RevenueManagement/FinishPaymentOrReceipt",
                    data: this.submitData,
                  })
                  .then((res) => {
                    this.$util.successMsg(res.errmsg);
                    this.$emit("closeFinish", true);
                  })
                  .catch(() => {
                    this.canSubmit = true;
                  });
              } else {
                return false;
              }
            });
          })
          .catch(() => {});
      } else {
        this.$refs["submitData"].validate((valid) => {
          if (valid) {
            this.canSubmit = false;
            this.$util
              .axiosPost({
                url: "/api/RevenueManagement/FinishPaymentOrReceipt",
                data: this.submitData,
              })
              .then((res) => {
                this.$util.successMsg(res.errmsg);
                this.$emit("closeFinish", true);
              })
              .catch(() => {
                this.canSubmit = true;
              });
          } else {
            return false;
          }
        });
      }
    },
    //  结算方式
    getPay() {
      this.$util.getPay().then((data) => {
        this.payWayList = data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
